import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Search, CrudService, MessageService, SortDirection } from 'elbuild-ui-lib-core';
import { Partecipant, Project, company } from 'toolbandi-ui-lib';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PartecipantEditComponent } from '../partecipant-edit/partecipant-edit.component';
import { DialogService } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-partecipant-list',
	templateUrl: './partecipant-list.component.html',
	styleUrls: ['./partecipant-list.component.scss']
})
export class PartecipantListComponent implements OnInit {

	hoverPartecipant: any;
	@Input()
	projectid: number;
	project: Project;

	loading: boolean = false;
	rows: Partecipant[];

	advancedSearch: Search = new Search('partecipant', 'name', 'partecipant');

	@Input()
	usercompanyid: number;
	@Output()
	onAddPartecipant = new EventEmitter();
	@Output()
	onDeletePartecipant = new EventEmitter();


	get page() {
		if (this.advancedSearch) {
			return this.advancedSearch.page;
		} else {
			return undefined;
		}
	}

	constructor(
		private partecipantService: CrudService<Partecipant>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private dialogService: DialogService,
		private projectService: CrudService<Project>,
		private modalService: NgbModal
	) {
		this.advancedSearch.setSortDirection(SortDirection.DESCENDING);
		this.advancedSearch.setSortField('budget');

	}

	ngOnInit(): void {
		this.loadProject();
		this.loadPartecipants();
	}

	loadProject(): void {
		this.projectService.getEntity(Project, 'project', this.projectid).subscribe((data: Project) => {
			this.project = data;
		});
	}

	loadPartecipants(): void {
		this.loading = true;
		this.rows = [];

		if (this.projectid) {
			this.advancedSearch.addSimpleFilter('projectid', this.projectid);
		}

		const datarequest = this.partecipantService.searchEntities(Partecipant, 'partecipant', this.advancedSearch, this.advancedSearch.page);
		const countrequest = this.partecipantService.countEntities(Partecipant, 'partecipant', this.advancedSearch);

		forkJoin([datarequest, countrequest]).subscribe(results => {
			this.advancedSearch.page.setTotal(results[1].ct);
			this.rows = results[0];
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});
	}

	onPageChange(pageInfo: any) {
		this.advancedSearch.page.setPageNumber(pageInfo.offset);
		this.loadPartecipants();
	}

	onSortChange(sortInfo: any) {
		const sort = sortInfo.sorts[0];
		this.advancedSearch.setSortField(sort.prop);
		this.advancedSearch.setSortDirection(sort.dir);
		this.loadPartecipants();
	}

	edit(partecipantid: number): void {
		const modal = this.modalService.open(PartecipantEditComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});
		modal.componentInstance.projectid = this.projectid;
		modal.componentInstance.load(partecipantid);

		modal.result.then((partecipant) => {
			this.loadPartecipants();
			if (partecipant) {
				this.onAddPartecipant.emit(partecipant);
			}
		}).catch(() => { });
	}

	delete(partecipant: Partecipant, event: any): void {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-partecipant-delete'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.partecipantService.deleteEntity(Partecipant, 'partecipant', partecipant).subscribe(() => {
					this.translateService.get(['labels.partecipant-deleted', 'labels.partecipants']).subscribe(messages => {
						this.messageService.sendSuccess(messages['labels.partecipant-deleted'], messages['labels.partecipants']);
						this.onDeletePartecipant.emit(partecipant);
						this.loadPartecipants();
					});
				});
			}
		});
	}

}
